export default `
.dte-sheet--full .dte-header-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);
  gap: 10px;
  margin-bottom: 10px;
}

.dte-sheet--full .dte-header-layout__issuer {
  display: grid;
  gap: 10px;
}

.dte-sheet--full .dte-header-layout__meta {
  display: grid;
  gap: 10px;
}

.dte-sheet--full .dte-banner-card {
  margin-top: 8px;
}

.dte-sheet--full .dte-detail-block {
  display: grid;
  gap: 10px;
}

.dte-sheet--full .dte-summary {
  grid-template-columns: 1fr;
  align-items: start;
}

.dte-sheet--full .dte-summary--single {
  grid-template-columns: 1fr;
}

.dte-sheet--full .dte-footer-card {
  grid-column: 1 / -1;
  width: 100%;
}

.dte-sheet--full .dte-card {
  border-color: var(--dte-table-border);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.6);
}

.dte-sheet--full .dte-card__header {
  background:
    linear-gradient(180deg, var(--dte-card-header-gradient-strong) 0%, var(--dte-card-header-gradient-soft) 100%),
    var(--dte-brand);
  color: var(--dte-brand-contrast);
}

.dte-sheet--full .dte-business-card {
  padding: 8px 10px;
}

.dte-sheet--full .dte-business-card__media {
  min-width: 200px;
  max-width: 280px;
}

.dte-sheet--full .dte-business-card__info .dte-definition-list__row {
  grid-template-columns: 108px minmax(0, 1fr);
  gap: 6px;
  font-size: var(--dte-text-font-size);
  line-height: 1.14;
}

.dte-sheet--full .dte-header-layout__meta .dte-card__body {
  padding: 8px 10px;
}

.dte-sheet--full .dte-header-layout__meta .dte-card__header {
  padding: 5px 9px;
  font-size: calc(var(--dte-title-font-size) - 6px);
  line-height: 1.05;
}

.dte-sheet--full .dte-header-layout__meta .dte-card__header--document-title {
  padding: 9px 10px;
  font-size: calc(var(--dte-title-font-size) - 2px);
  letter-spacing: 0.02em;
  line-height: 1.12;
}

.dte-sheet--full .dte-header-layout__meta .dte-definition-list {
  gap: 2px;
}

.dte-sheet--full .dte-header-layout__meta .dte-definition-list__row {
  grid-template-columns: 112px minmax(0, 1fr);
  gap: 5px;
  font-size: calc(var(--dte-text-font-size) - 1px);
  line-height: 1.12;
}

.dte-sheet--full .dte-header-layout__meta .dte-document-card {
  gap: 6px;
}

.dte-sheet--full .dte-table {
  border-color: var(--dte-table-border);
}

.dte-sheet--full .dte-table thead th {
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.14) 0%, rgba(255, 255, 255, 0) 100%),
    var(--dte-brand);
}

.dte-sheet--full .dte-table tbody tr:nth-child(even) td {
  background: rgba(236, 243, 249, 0.8);
}

.dte-sheet--full .dte-detail-table-section--full {
  --dte-full-detail-item-width: 28px;
  --dte-full-detail-text-width: 40px;
  --dte-full-detail-number-width: 56px;
  --dte-full-detail-description-min: 140px;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}

.dte-sheet--full .dte-detail-table-section--balanced {
  --dte-full-detail-item-width: 34px;
  --dte-full-detail-text-width: 56px;
  --dte-full-detail-number-width: 64px;
  --dte-full-detail-description-min: 180px;
}

.dte-sheet--full .dte-detail-table-section--relaxed {
  --dte-full-detail-item-width: 38px;
  --dte-full-detail-text-width: 72px;
  --dte-full-detail-number-width: 64px;
  --dte-full-detail-description-min: 220px;
}

.dte-sheet--full .dte-detail-table-section--full .dte-table--detail {
  width: 100%;
  max-width: 100%;
  table-layout: fixed;
}

.dte-sheet--full .dte-detail-table-section--full .dte-table--detail th,
.dte-sheet--full .dte-detail-table-section--full .dte-table--detail td {
  padding: 3px 4px;
  line-height: 1.06;
  overflow-wrap: anywhere;
}

.dte-sheet--full .dte-detail-table-section--full .dte-table--detail td {
  font-size: var(--dte-detail-font-size);
}

.dte-sheet--full .dte-detail-table-section--full .dte-table--detail thead th {
  font-size: calc(var(--dte-detail-font-size) - 3px);
  line-height: 1;
  letter-spacing: 0.02em;
  vertical-align: middle;
  white-space: normal;
  word-break: normal;
}

.dte-sheet--full .dte-detail-table-section--full .dte-table--detail thead th[style*="width"] {
  width: var(--dte-full-detail-text-width) !important;
  max-width: var(--dte-full-detail-text-width) !important;
}

.dte-sheet--full .dte-detail-table-section--full .dte-table--detail thead th.dte-table__right {
  width: var(--dte-full-detail-number-width) !important;
  max-width: var(--dte-full-detail-number-width) !important;
}

.dte-sheet--full .dte-detail-table-section--full .dte-table--detail thead th:first-child {
  width: var(--dte-full-detail-item-width) !important;
  max-width: var(--dte-full-detail-item-width) !important;
}

.dte-sheet--full .dte-detail-table-section--full .dte-table--detail thead th:not(.dte-table__right):not([style]) {
  min-width: var(--dte-full-detail-description-min);
}

.dte-sheet--full .dte-detail-table-section--full .dte-table--detail .dte-table__description {
  min-width: var(--dte-full-detail-description-min);
  white-space: pre-line;
  word-break: normal;
  overflow-wrap: anywhere;
}

.dte-sheet--full .dte-detail-table-section--full .dte-table--detail .dte-table__right {
  white-space: normal;
  word-break: normal;
  overflow-wrap: anywhere;
}

.dte-sheet--full .dte-total-row.is-emphasis {
  font-size: calc(var(--dte-title-font-size) - 4px);
}
`;
